export default function IconHeader() {
    return (
        <svg
            fill="none"
            viewBox="0 0 229 143"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M73.512 37.075H63.436c-.97.001-1.898.385-2.583 1.068a3.64 3.64 0 00-1.07 2.575v10.89a12.905 12.905 0 01-6.937-2.663 12.847 12.847 0 01-4.179-5.676 12.808 12.808 0 012.7-13.274 12.89 12.89 0 016.065-3.607 12.92 12.92 0 017.062.124 12.887 12.887 0 015.935 3.817 12.828 12.828 0 013.083 6.746zM183 112.533h10.076a3.664 3.664 0 002.583-1.068 3.637 3.637 0 001.071-2.574V98a12.904 12.904 0 016.937 2.663 12.84 12.84 0 014.178 5.677 12.815 12.815 0 01-2.699 13.273 12.918 12.918 0 01-13.128 3.484 12.895 12.895 0 01-5.935-3.817 12.824 12.824 0 01-3.083-6.747z"
                fill="#EDEEF9"
            />
            <path
                d="M192.462 36.692H63.436a4.049 4.049 0 00-2.855 1.18 4.024 4.024 0 00-1.184 2.846v67.864a4.022 4.022 0 001.184 2.845 4.047 4.047 0 002.854 1.181h129.027a4.047 4.047 0 002.854-1.181 4.022 4.022 0 001.184-2.845V40.718a4.024 4.024 0 00-1.184-2.846 4.048 4.048 0 00-2.854-1.18zm3.654 71.89a3.654 3.654 0 01-3.654 3.642H63.435a3.657 3.657 0 01-2.582-1.067 3.64 3.64 0 01-1.071-2.575V40.718a3.64 3.64 0 011.071-2.575 3.662 3.662 0 012.582-1.068h129.027a3.66 3.66 0 012.582 1.068 3.642 3.642 0 011.072 2.575v67.864z"
                fill="#3F3D56"
            />
            <path
                d="M186.117 47.69H69.781a.193.193 0 01-.192-.191.191.191 0 01.192-.192h116.336a.19.19 0 01.135.056.188.188 0 010 .271.19.19 0 01-.135.056z"
                fill="#3F3D56"
            />
            <path
                d="M102.663 104.364a.192.192 0 01-.192-.191V41.101a.191.191 0 01.192-.191.192.192 0 01.192.191v63.072a.19.19 0 01-.192.191zM131.698 104.364a.192.192 0 01-.192-.191V41.101a.191.191 0 01.192-.191.192.192 0 01.192.191v63.072a.19.19 0 01-.192.191zM160.734 104.364a.192.192 0 01-.192-.191V41.101a.191.191 0 01.192-.191.192.192 0 01.193.191v63.072a.192.192 0 01-.193.191z"
                fill="#3F3D56"
            />
            <path
                d="M83.994 67.478h-7.026a.867.867 0 01-.865-.863v-8.266a.862.862 0 01.865-.863h7.026a.867.867 0 01.865.863v8.266a.862.862 0 01-.865.863zM93.993 91.058h-7.026a.868.868 0 01-.865-.863v-8.266a.862.862 0 01.865-.863h7.026a.867.867 0 01.865.863v8.266a.862.862 0 01-.865.863zM116.684 72.462h-7.027a.866.866 0 01-.865-.863v-8.266a.867.867 0 01.865-.863h7.027a.867.867 0 01.865.863v8.266a.863.863 0 01-.865.863zM146.103 63.452h-7.026a.866.866 0 01-.865-.863v-8.266a.867.867 0 01.865-.863h7.026a.868.868 0 01.866.863v8.266a.863.863 0 01-.866.863zM173.217 63.452h-7.027a.866.866 0 01-.865-.863v-8.266a.862.862 0 01.865-.863h7.027a.867.867 0 01.865.863v8.266a.866.866 0 01-.865.863z"
                fill="#7B67FB"
            />
            <path
                d="M185.716 65.752h-7.026a.867.867 0 01-.866-.862v-8.267a.862.862 0 01.866-.862h7.026a.867.867 0 01.865.862v8.267a.867.867 0 01-.865.863zM180.14 80.514h-7.027a.866.866 0 01-.865-.863v-8.266a.862.862 0 01.865-.863h7.027a.867.867 0 01.865.863v8.266a.863.863 0 01-.865.863z"
                fill="#E6E6E6"
            />
            <path
                d="M156.295 77.446h-7.026a.867.867 0 01-.866-.862v-8.267a.867.867 0 01.866-.862h7.026a.867.867 0 01.865.862v8.267a.867.867 0 01-.865.863z"
                fill="#FF6584"
            />
            <path
                d="M142.643 80.514h-7.027a.866.866 0 01-.865-.863v-8.266a.867.867 0 01.865-.863h7.027a.867.867 0 01.865.863v8.266a.863.863 0 01-.865.863zM113.223 93.55h-7.027a.867.867 0 01-.865-.863v-8.266a.862.862 0 01.865-.863h7.027a.867.867 0 01.865.863v8.266a.862.862 0 01-.865.863z"
                fill="#E6E6E6"
            />
            <path
                d="M77.648 82.623h-7.026a.867.867 0 01-.865-.863v-8.267a.862.862 0 01.865-.862h7.026a.867.867 0 01.866.862v8.267a.862.862 0 01-.866.862z"
                fill="#FF6584"
            />
            <path
                d="M97.454 67.478h-7.026a.867.867 0 01-.865-.863v-8.266a.862.862 0 01.865-.863h7.026a.868.868 0 01.865.863v8.266a.862.862 0 01-.865.863z"
                fill="#E6E6E6"
            />
            <path
                d="M91.702 44.552h-10.96a.77.77 0 01-.77-.767.766.766 0 01.77-.767h10.96a.77.77 0 01.77.767.766.766 0 01-.77.767zM122.66 44.552H111.7a.77.77 0 01-.769-.767.766.766 0 01.769-.767h10.96a.77.77 0 01.77.767.767.767 0 01-.77.767zM151.696 44.552h-10.96a.77.77 0 01-.769-.767.766.766 0 01.769-.767h10.96a.77.77 0 01.77.767.77.77 0 01-.77.767zM178.81 44.552h-10.961a.767.767 0 110-1.534h10.961a.766.766 0 110 1.534z"
                fill="#CCC"
            />
            <path
                d="M67.153 100.701a1.938 1.938 0 01-1.408-.83 1.925 1.925 0 01-.265-1.61l-4.93-4.575 2.607-.659 4.847 3.92A1.942 1.942 0 0169.25 99.2a1.948 1.948 0 01-2.098 1.5zM73.96 134.511h2.357l1.121-9.066H73.96v9.066z"
                fill="#FFB8B8"
            />
            <path
                d="M80.863 136.693h-7.409v-2.854h4.547c.759 0 1.487.301 2.024.836a2.85 2.85 0 01.838 2.018z"
                fill="#2F2E41"
            />
            <path
                d="M57.795 132.814l2.278.605 3.423-8.473-3.362-.892-2.34 8.76z"
                fill="#FFB8B8"
            />
            <path
                d="M63.904 136.694l-7.16-1.9.737-2.758 4.393 1.166c.734.194 1.36.672 1.74 1.327.381.655.486 1.433.29 2.165zM76.95 132.794h-3.596a.911.911 0 01-.91-.823l-2.183-22.608a.718.718 0 00-.647-.646.723.723 0 00-.76.509l-6.341 21.126a.91.91 0 01-1.096.622l-3.346-.834a.922.922 0 01-.563-.417.907.907 0 01-.1-.692c.054-.213 5.463-21.285 5.51-21.502 1.225-9.004 2.691-11.417 3.479-12.713l.18-.299c.067-.117.482-1.274.746-2.025a.918.918 0 01.468-.57c3.31-1.688 7.182-.52 8.29-.122a.899.899 0 01.45.348c3.323 4.998 1.692 34.026 1.331 39.795a.91.91 0 01-.911.851z"
                fill="#2F2E41"
            />
            <path
                d="M67.667 75.529a4.716 4.716 0 004.723-4.709c0-2.6-2.115-4.708-4.723-4.708a4.716 4.716 0 00-4.723 4.709c0 2.6 2.115 4.708 4.723 4.708z"
                fill="#FFB8B8"
            />
            <path
                d="M67.167 93.406l-.034-.033c-.063-.061-6.356-6.207-5.542-11.89.349-2.43 2.321-3.984 5.705-4.492a5.23 5.23 0 013.571.759 5.203 5.203 0 012.198 2.907L76.41 92.06l-9.244 1.346z"
                fill="#CCC"
            />
            <path
                d="M63.946 97.778l-4.484-4.443a2.515 2.515 0 01-.669-2.375l2.17-8.803a1.982 1.982 0 011.73-1.5c.271-.029.545 0 .805.081a1.99 1.99 0 011.31 2.453l-2.286 7.744 3.696 3.956-2.272 2.886z"
                fill="#CCC"
            />
            <path
                d="M87.996 82.618a1.929 1.929 0 01-1.25 1.052 1.94 1.94 0 01-1.612-.28l-5.986 3.093.265-2.627 5.307-3.274a1.945 1.945 0 013.381.663c.135.455.098.943-.105 1.373z"
                fill="#FFB8B8"
            />
            <path
                d="M84.48 84.574l-5.835 2.514a2.47 2.47 0 01-2.4-.257l-7.42-5.3a1.987 1.987 0 01-.754-2.16c.074-.26.202-.503.375-.713a2.004 2.004 0 012.77-.301l6.363 4.992 5.058-1.95 1.843 3.175z"
                fill="#CCC"
            />
            <path
                d="M68.45 72.33c.583-.729 1.671-.768 2.472-1.248 1.048-.629 1.482-2.034 1.144-3.206-.338-1.173-1.334-2.086-2.477-2.523-1.142-.437-2.413-.443-3.618-.231-1.794.314-3.56 1.149-4.654 2.6-1.095 1.453-1.373 3.58-.381 5.103.455.7 1.159 1.278 1.34 2.093.24 1.07-.513 2.1-1.319 2.846-.919.848-1.972 1.559-2.777 2.515-.805.957-1.341 2.264-.974 3.457.307 1 1.203 1.737 2.184 2.106.982.369 2.051.422 3.1.443 1.019.02 2.1-.005 2.959-.553.919-.586 1.409-1.698 1.445-2.785.036-1.086-.328-2.151-.816-3.123-.29-.58-.63-1.141-.823-1.76-.193-.619-.226-1.321.083-1.891.326-.599.984-.96 1.655-1.092.035-.006.071-.013.11-.018a1.425 1.425 0 001.203-1.085c.043-.186.048-.38.015-.569-.077-.425-.07-.83.13-1.08z"
                fill="#2F2E41"
            />
            <path
                d="M131.42 134.712h-2.357l-1.122-9.066h3.48l-.001 9.066z"
                fill="#A0616A"
            />
            <path
                d="M127.378 134.04h4.547v2.854h-7.409a2.841 2.841 0 01.838-2.018 2.87 2.87 0 012.024-.836z"
                fill="#2F2E41"
            />
            <path
                d="M148.526 132.049l-2.145.977-4.798-7.781 3.165-1.442 3.778 8.246z"
                fill="#A0616A"
            />
            <path
                d="M144.57 133.112l4.135-1.883 1.189 2.596-6.739 3.069a2.843 2.843 0 01.509-3.13c.256-.275.564-.496.906-.652z"
                fill="#2F2E41"
            />
            <path
                d="M141.66 104.145a1.926 1.926 0 00.154-2.952l2.772-6.268-3.521.594-2.092 5.862a1.934 1.934 0 00.112 2.572 1.948 1.948 0 002.575.192z"
                fill="#A0616A"
            />
            <path
                d="M131.269 132.321h-2.252a.866.866 0 01-.863-.8l-1.228-32.697a.857.857 0 01.259-.68.861.861 0 01.688-.241l13.025 1.379a.867.867 0 01.781.842l.273 14.423a.662.662 0 00.045.229l5.343 13.813a.854.854 0 01-.019.666.877.877 0 01-.489.454l-2.283.838a.863.863 0 01-1.068-.415l-6.564-12.723a.852.852 0 01-.077-.219l-1.122-5.386a.667.667 0 00-.689-.534.673.673 0 00-.638.594l-2.262 19.693a.865.865 0 01-.86.764z"
                fill="#2F2E41"
            />
            <path
                d="M132.391 73.258a4.716 4.716 0 004.723-4.709c0-2.6-2.115-4.708-4.723-4.708a4.715 4.715 0 00-4.723 4.708c0 2.6 2.114 4.709 4.723 4.709z"
                fill="#A0616A"
            />
            <path
                d="M135.63 101.814a16.906 16.906 0 01-9.013-2.722l-.046-.032.005-.055 1.807-20.976c.062-.712.38-1.377.897-1.872a2.967 2.967 0 011.91-.824c2.341-.107 5.486.028 7.17 1.278 2.544 1.89 3.77 4.734 3.364 7.805-.843 6.368.112 14.959.223 15.917l.008.069-.063.029a14.893 14.893 0 01-6.262 1.383z"
                fill="#7B67FB"
            />
            <path
                d="M141.925 100.369a.949.949 0 01-.386-.082.953.953 0 01-.322-.229l-1.033-1.124a.965.965 0 01-.213-.919l2.356-7.949-3.585-7.504a1.692 1.692 0 01-.116-1.127 1.695 1.695 0 013.137-.4l4.864 7.868a2.28 2.28 0 01.139 2.147l-3.963 8.755a.965.965 0 01-.878.564z"
                fill="#7B67FB"
            />
            <path
                d="M108.636 85.185a1.939 1.939 0 002.884-.686l6.814.88-1.566-3.198-6.231-.347a1.949 1.949 0 00-2.443.834 1.934 1.934 0 00.542 2.517z"
                fill="#A0616A"
            />
            <path
                d="M123.656 86.932c-.119 0-.237-.008-.355-.025l-10.72-1.482a1.068 1.068 0 01-.879-.755 1.073 1.073 0 01.111-.85l.887-1.466a1.073 1.073 0 01.914-.515h.002l9.344.01 6.979-6.233a1.903 1.903 0 012.26-.198 1.888 1.888 0 01.86 1.956 1.885 1.885 0 01-.528.986l-6.964 7.722a2.564 2.564 0 01-1.911.85z"
                fill="#7B67FB"
            />
            <path
                d="M132.928 72.738c.431-.996.797-2.322-.031-3.026-.48-.408-1.172-.41-1.801-.46-1.772-.143-3.597-.956-4.463-2.504-.867-1.549-.383-3.85 1.252-4.55 1.101-.47 2.364-.15 3.517.177l3.463.979c1.029.29 2.109.611 2.849 1.38 1.181 1.227 1.093 3.3.155 4.72s-2.351 2.9-3.968 3.44l-.973-.156z"
                fill="#2F2E41"
            />
            <path
                d="M180.695 136.956H38.729a.225.225 0 01-.23-.228.223.223 0 01.067-.161.214.214 0 01.075-.05.24.24 0 01.088-.017h141.966c.03 0 .06.006.088.017a.206.206 0 01.074.05.206.206 0 01.05.074.223.223 0 01-.05.249.222.222 0 01-.162.066z"
                fill="#3F3D56"
            />
            <path
                d="M43.214 28.885c.104 0 .203.04.276.112.073.073.114.17.114.273v1.282c0 .102-.04.2-.114.271a.393.393 0 01-.551 0 .381.381 0 01-.115-.271V29.27c0-.103.041-.2.115-.273a.393.393 0 01.275-.112zm-2.485 1.01a.393.393 0 01.55 0l.91.898a.385.385 0 01.097.425.387.387 0 01-.369.24.393.393 0 01-.278-.122l-.91-.897a.382.382 0 010-.544zm4.971 0a.382.382 0 010 .544l-.91.897a.39.39 0 01-.431.095.39.39 0 01-.244-.364.38.38 0 01.124-.274l.91-.898a.393.393 0 01.551 0zm-5.996 2.451c0-.101.041-.2.114-.271a.393.393 0 01.276-.113h1.3c.104 0 .203.04.276.113a.382.382 0 010 .543.393.393 0 01-.276.113h-1.3a.393.393 0 01-.276-.113.382.382 0 01-.114-.272zm4.252-.135c-.444-.376-1.132-.064-1.132.514v5.781c0 .62.778.914 1.198.452l1.359-1.5a.8.8 0 01.56-.26l1.997-.078c.622-.025.892-.79.419-1.19l-4.4-3.719zm-.352 6.052v-5.337l4.063 3.434-1.758.07a1.588 1.588 0 00-1.109.516l-1.196 1.317z"
                fill="#fff"
            />
            <rect
                height="18"
                width="18"
                fill="#FCC65A"
                rx="8.019"
                transform="rotate(7.536 148.86 8.956)"
                x="148.86"
                y="8.956"
            />
            <rect
                height="18"
                width="18"
                fill="#59C6B6"
                rx="8.019"
                transform="rotate(15 193.159 83.956)"
                x="193.159"
                y="83.956"
            />
            <rect
                height="18"
                width="18"
                fill="#7B67FB"
                rx="6.476"
                transform="rotate(-15 33.5 27.615)"
                x="33.5"
                y="27.615"
            />
            <rect
                height="18"
                width="18"
                fill="#EF7A57"
                rx="6.415"
                transform="rotate(15 30.16 93.956)"
                x="30.159"
                y="93.956"
            />
            <g clipPath="url(#a)" fill="#fff">
                <path d="M159.663 17.86l.075-.584a2.88 2.88 0 00-.595-2.143 2.962 2.962 0 00-1.955-1.105 2.963 2.963 0 00-2.17.58 2.88 2.88 0 00-1.113 1.924l-.075.585c-.391.113-.74.335-1.005.64a2.05 2.05 0 00-.484 1.081l-.314 2.465a2.06 2.06 0 00.425 1.53c.342.435.844.719 1.396.79l4.166.531c.553.07 1.11-.08 1.549-.415.44-.335.726-.83.796-1.374l.314-2.465c.051-.4-.018-.805-.197-1.167a2.096 2.096 0 00-.813-.872zm-4.925-1.222c.07-.544.356-1.039.796-1.374a2.112 2.112 0 011.549-.414c.553.07 1.055.354 1.397.79.341.434.494.985.425 1.53l-.053.41-4.166-.53.052-.412zm4.788 5.621a1.234 1.234 0 01-.477.825 1.27 1.27 0 01-.93.248l-4.166-.53a1.269 1.269 0 01-.838-.474 1.232 1.232 0 01-.255-.919l.314-2.465c.042-.327.213-.623.477-.825a1.27 1.27 0 01.93-.248l4.166.531c.332.042.633.213.838.474.205.26.297.591.255.918l-.314 2.465z" />
                <path d="M156.455 19.78a.422.422 0 00-.31.082.411.411 0 00-.159.275l-.105.822a.412.412 0 00.085.306.423.423 0 00.589.075.411.411 0 00.159-.275l.105-.822a.412.412 0 00-.085-.306.422.422 0 00-.279-.157z" />
            </g>
            <g clipPath="url(#b)">
                <path
                    d="M197.779 95.085a1.893 1.893 0 01-1.385-1.579 1.886 1.886 0 011.998-2.133 1.89 1.89 0 11-.613 3.712zm.761-2.84a1.049 1.049 0 10-.543 2.027 1.049 1.049 0 00.543-2.026zm1.195 7.712l.054-.202a3.15 3.15 0 00-6.085-1.63l-.055.202a.422.422 0 00.616.473.423.423 0 00.196-.256l.054-.203a2.313 2.313 0 012.829-1.633 2.31 2.31 0 011.634 2.83l-.055.202a.42.42 0 00.812.217zm4.194-1.05a2.939 2.939 0 00-4.166-3.384.422.422 0 00-.086.695.42.42 0 00.466.054 2.096 2.096 0 012.271.245 2.104 2.104 0 01.704 2.173.418.418 0 00.297.514.42.42 0 00.514-.297zm-1.658-4.357a1.889 1.889 0 01.613-3.712 1.894 1.894 0 011.702 2.375 1.896 1.896 0 01-2.315 1.337zm.761-2.84a1.052 1.052 0 00-1.32.945 1.054 1.054 0 001.185 1.11 1.048 1.048 0 00.772-1.566 1.048 1.048 0 00-.637-.49z"
                    fill="#fff"
                />
            </g>
            <g clipPath="url(#c)">
                <g clipPath="url(#d)">
                    <path
                        d="M33.198 102.105a1.305 1.305 0 01-.79-.604l-.493-.746a.432.432 0 11.724-.474l.506.768a.443.443 0 00.264.22.432.432 0 00.342-.04l1.892-1.026c.1-.051.217-.06.324-.026a.43.43 0 01.092.784l-1.885 1.021a1.29 1.29 0 01-.976.123zm8.6 1.411a.43.43 0 00-.307-.529l-4.188-1.122a.434.434 0 00-.53.304.431.431 0 00.306.529l4.188 1.123a.432.432 0 00.53-.305zm-8.518 1.801l1.885-1.021a.433.433 0 00.185-.592.433.433 0 00-.6-.166l-1.892 1.026a.442.442 0 01-.592-.158l-.488-.84a.434.434 0 00-.79.107.429.429 0 00.04.324l.486.839a1.303 1.303 0 001.768.481h-.002zm7.624 1.534a.434.434 0 00-.307-.529L36.41 105.2a.43.43 0 00-.53.305.43.43 0 00.043.327.437.437 0 00.264.202l4.188 1.122a.434.434 0 00.53-.305zm-8.517 1.801l1.883-1.021a.434.434 0 00.236-.428.432.432 0 00-.489-.386.448.448 0 00-.163.056l-1.89 1.026a.43.43 0 01-.497-.043.42.42 0 01-.11-.137l-.505-.767a.433.433 0 00-.6-.125.432.432 0 00-.125.598l.493.746a1.3 1.3 0 00.786.603 1.3 1.3 0 00.982-.121l-.001-.001zm7.624 1.535a.431.431 0 00-.308-.53l-4.188-1.122a.434.434 0 00-.53.305.432.432 0 00.307.529l4.188 1.122a.43.43 0 00.53-.304z"
                        fill="#fff"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="a">
                    <path
                        d="M0 0h10.08v9.94H0z"
                        fill="#fff"
                        transform="rotate(7.265 -29.374 1205.361)"
                    />
                </clipPath>
                <clipPath id="b">
                    <path
                        d="M0 0h10.08v10.08H0z"
                        fill="#fff"
                        transform="rotate(15 -239.923 789.448)"
                    />
                </clipPath>
                <clipPath id="c">
                    <path
                        d="M0 0h12.6v12.425H0z"
                        fill="#fff"
                        transform="rotate(15 -354.573 169.802)"
                    />
                </clipPath>
                <clipPath id="d">
                    <path
                        d="M0 0h11.967v12.121H0z"
                        fill="#fff"
                        transform="rotate(15 -355.258 170.518)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
}
